var recaptchaLoaded = false;
var recaptchaMessagePublished = false;
var callback_recaptcha = function () {
    recaptchaLoaded = true;
    checkAsyncLoad();
};

var googleMapsLoaded = false;
var googleMapsMessagePublished = false;
var callback_googlemaps = function () {
    googleMapsLoaded = true;
    checkAsyncLoad();
};

var venddLoaded = false;
var callback_vendd = function () {
    venddLoaded = true;
    checkAsyncLoad();
};

var checkAsyncLoad = function () {
    if (!venddLoaded) 
        return;

    if (recaptchaLoaded && !recaptchaMessagePublished) {
        Vendd.MessageBus.publishAsync('checkAsyncLoad', new Vendd.Plugins.Messages.RecaptcaLoaded());
        recaptchaMessagePublished = true;
    }
    
    if (googleMapsLoaded && !googleMapsMessagePublished) {
        Vendd.MessageBus.publishAsync('checkAsyncLoad', new Vendd.Plugins.Messages.GoogleMapsLoaded());
        googleMapsMessagePublished = true;
    }

};

function checkout_callback_googlemaps() {

    angular.element(".x-checkoutstore").ready(function () {
        if ($('.x-checkoutstore').scope() && $('.x-checkoutstore').scope().Control && typeof ($('.x-checkoutstore').scope().Control.SetMap) === 'function') {
            $('.x-checkoutstore').scope().Control.SetMap(true);
        }
    }); 

}